import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Styles } from './style';
import { contactFormData } from '../FormContact/contactFormData';
import AuthenticatedLayout from '@screens/Authenticated/Layout/Layout';

const ContactDetailScreen: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const contact = contactFormData[Number(id)];

  if (!contact) {
    return <h1>Contato não encontrado</h1>;
  }

  return (
    <AuthenticatedLayout>
      <h1>CONTATOS VIA SITE</h1>
      <Styles.RectangleBar />
      <Styles.UserCard>
        <Styles.UserInfo>
          <Styles.UserName>
            <h1>{contact.name}</h1>
          </Styles.UserName>
          <Styles.UserContact>
            <p>
              <strong>Email:</strong> {contact.email}
            </p>
            <p>
              <strong>Telefone:</strong> {contact.phone}
            </p>
            <p>
              <strong>Assunto:</strong> {contact.subject}
            </p>
            <p>
              <strong>Mensagem:</strong> {contact.message}
            </p>
          </Styles.UserContact>
        </Styles.UserInfo>
      </Styles.UserCard>
      <Styles.Buttons>
        <button onClick={() => navigate(-1)}>Voltar</button>
      </Styles.Buttons>
    </AuthenticatedLayout>
  );
};

export default ContactDetailScreen;
